// Deal stages
export const DEAL_STAGES = {
  BACKLOG: 'Backlog',
  LEAD: 'Lead',
  QUALIFIED: 'Qualified',
  PROPOSED: 'Proposed',
  CLOSED_WON: 'Closed as Won',
  CLOSED_LOST: 'Close as Lost',
  CANCELLED: 'Cancelled'
};

export const CLOSED_STAGES = [
  DEAL_STAGES.CLOSED_WON,
  DEAL_STAGES.CLOSED_LOST,
  DEAL_STAGES.CANCELLED
]; 